<div class="row">
  <div class="col">
    <h4 class="mb-3">Dados do cartão de crédito</h4>
  </div>
</div>
<form (submit)="Save()" [formGroup]="form" class="mr-3">
  <div class="row mt-2">
    <div class="col-12">
      <label for="nome">Nome</label>
      <input
        formControlName="nome"
        [(ngModel)]="creditCard.nome"
        placeholder="Nome completo, como mostrado no cartão"
        name="nome"
        type="text"
        class="form-control"
        required
        disabled="{{ !this.HabilitarEdicaoCampos() }}"
      />
      <!-- <small class="text-muted">Nome completo, como mostrado no cartão.</small> -->
      <div *ngIf="error && form.get('nome').invalid" class="error">
        Verifique este campo!
      </div>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-12">
      <label for="numero">Número do cartão</label>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <input
        formControlName="numero"
        [(ngModel)]="creditCard.numero"
        type="text"
        class="form-control"
        id="creditCardNumber"
        placeholder="Número do Cartão"
        mask="0000 0000 0000 0000"
        required
        disabled="{{ !this.HabilitarEdicaoCampos() }}"
        (input)="change()"
      />
      <div *ngIf="error && form.get('numero').invalid" class="error">
        Verifique este campo!
      </div>
    </div>
    <!-- <div class="col">
    <input
    [(ngModel)]="creditCard.numero1"
    #currentInput
    (input)="moveToNext(currentInput, nextInput)"
    maxlength="4"
    type="text"
    class="form-control"
    id="numero"
    required
    disabled="{{ !this.HabilitarEdicaoCampos() }}"
    (change)="change()"
    />
        <div class="invalid-feedback">
          O número do cartão de crédito é obrigatório.
        </div>
      </div>
      <div class="col">
        <input
        [(ngModel)]="creditCard.numero2"
        #nextInput
        (input)="moveToNext(nextInput, nextInput2)"
        type="text"
        maxlength="4"
        class="form-control"
        id="numero"
        required
        disabled="{{ !this.HabilitarEdicaoCampos() }}"
        (change)="change()"
        />
        <div class="invalid-feedback">
          O número do cartão de crédito é obrigatório.
        </div>
      </div>
      <div class="col">
        <input
        [(ngModel)]="creditCard.numero3"
        #nextInput2
        (input)="moveToNext(nextInput2, nextInput3)"
        type="text"
        class="form-control"
        id="numero"
        maxlength="4"
        required
        disabled="{{ !this.HabilitarEdicaoCampos() }}"
        (change)="change()"
        />
        <div class="invalid-feedback">
          O número do cartão de crédito é obrigatório.
        </div>
      </div>
      <div class="col">
        <input
        [(ngModel)]="creditCard.numero4"
        #nextInput3
        type="text"
        class="form-control"
        id="numero"
        maxlength="4"
        required
          disabled="{{ !this.HabilitarEdicaoCampos() }}"
          (change)="change()"
          (onBlur)="getCardFlag()"
          />
          <div class="invalid-feedback">
            O número do cartão de crédito é obrigatório.
          </div>
        </div>
        </div-->
    <div class="row mt-2">
      <div class="col-4">
        <label for="validadeMes">Validade - Mês</label>
        <select
          formControlName="mes"
          [(ngModel)]="creditCard.validadeMes"
          class="form-control"
          value="{{ creditCard.validadeMes }}"
          id="validadeMes"
          disabled="{{ !this.HabilitarEdicaoCampos() }}"
        >
          <option *ngFor="let mes of this.meses" [value]="mes">
            {{ mes }}
          </option>
        </select>
        <div *ngIf="error && form.get('mes').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
      <div class="col-4">
        <label for="validadeAno">Validade - Ano</label>
        <select
          formControlName="ano"
          [(ngModel)]="creditCard.validadeAno"
          class="form-control"
          value="{{ creditCard.validadeAno }}"
          id="validadeAno"
          disabled="{{ !this.HabilitarEdicaoCampos() }}"
        >
          <option *ngFor="let ano of this.anos" [value]="ano">{{ ano }}</option>
        </select>
        <div *ngIf="error && form.get('ano').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
      <div class="col-4">
        <label for="codigoSeguranca">CVV</label>
        <input
          [(ngModel)]="creditCard.codigoSeguranca"
          formControlName="cvv"
          mask="000"
          type="text"
          class="form-control"
          id="codigoSeguranca"
          required
          disabled="{{ !this.HabilitarEdicaoCampos() }}"
        />
        <div *ngIf="error && form.get('cvv').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
    </div>
    <div class="row" style="width: 100%;">
      <div class="col-6">
        <label for="codigoSeguranca">Parcelas</label>
        <select
          formControlName="parcelas"
          [(ngModel)]="creditCard.parcelas"
          type="number"
          class="form-control"
          id="codigoSeguranca"
          required
          disabled="{{ !this.HabilitarEdicaoCampos() }}"
        >
          <option *ngFor="let p of this.parcelas" [value]="p">{{p+"x"}} {{total/p | currency : "BRL" }}</option>
          <!-- <option value="1">1x {{ total / 1 | currency : "BRL" }}</option>
          <option value="2">2x {{ total / 2 | currency : "BRL" }}</option>
          <option value="3">3x {{ total / 3 | currency : "BRL" }}</option> -->
        </select>
        <div *ngIf="error && form.get('parcelas').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
      <div class="col-6" *ngIf="currentBandeira !== 'desconhecido'">
        <label>Bandeira</label>
        <input
        readonly
          formControlName="bandeira"
          class="form-control"
          type="text"
          [(ngModel)]="creditCard.bandeira"
        />
        <div *ngIf="error && form.get('bandeira').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
      <!-- <ng-template #elseBlockM> -->
        <div class="col-6" *ngIf="currentBandeira === 'desconhecido'">
          <label>Bandeira</label>
          <select formControlName="bandeira" class="form-control" [(ngModel)]="creditCard.bandeira">
            <option value=""></option>
            <option *ngFor="let b of bandeira" value="{{ b }}">
              {{ b }}
            </option>
          </select>
          <div *ngIf="error && form.get('bandeira').invalid" class="error">
            Verifique este campo!
          </div>
        </div>
      <!-- </ng-template> -->
    </div>

    <div class="row mt-2">
      <div class="col">
        <div
          *ngIf="this.HabilitarMensagemAutorizando()"
          class="alert alert-primary"
          role="alert"
        >
          Processando... <span class="spinner-border spinner-border-sm"></span>
        </div>
        <div
          *ngIf="this.HabilitarMensagemRetorno()"
          [ngClass]="
            this.HabilitarMensagemRetorno() &&
            paymentReturn &&
            paymentReturn.sucess
              ? 'alert alert-success'
              : 'alert alert-danger'
          "
          role="alert"
        >
          {{ paymentReturn.status }}
        </div>
      </div>
    </div>

    <div class="row mt-2 mb-2">
      <div class="col">
        <button class="btn btn-primary">
          <i class="icofont-check-circled"></i>Finalizar
        </button>
      </div>
    </div>
  </div>
</form>
